import { dictEnumListAll } from "@/api/COldForNew";
import { get } from "echarts/lib/CoordinateSystem";

export default {
  data() {
    return {
      OrderStateTypeEnum: [], //结算状态

    };
  },
  created() {
    this.getDictEnumList();

  },
  methods: {
    async getDictEnumList() {
      let res = await dictEnumListAll();
      if (res.statusCode === 200) {
        this.OrderStateTypeEnum = [];
        res.data.forEach(item => {
          switch (item.enumName) {
            case 'OrderStateType':
              this.OrderStateTypeEnum.push(item);
              break;

              break;
          }
        });
      }
    },

    async getSourceOrigin(data){
      let res= await getSourceOrigin(data);
      if(res.statusCode===200){
        return res.data;
      }
    }

  }
};



// WEBPACK FOOTER //
// ./src/views/order/enumMixin.js